import { STAFF_SUPPORT_EMAIL } from "../../../utils/userFacingError";

type MemberRestartApplicationGuardInput = {
  canStartNewApplication: boolean;
  hasUnsavedChanges: boolean;
  paymentSurfaceCleanupBlocksRestart: boolean;
};

type MemberRestartApplicationGuardResult = {
  allowed: boolean;
  blockedReason?: string;
};

export const getMemberRestartApplicationGuard = ({
  canStartNewApplication,
  hasUnsavedChanges,
  paymentSurfaceCleanupBlocksRestart,
}: MemberRestartApplicationGuardInput): MemberRestartApplicationGuardResult => {
  if (paymentSurfaceCleanupBlocksRestart) {
    return {
      allowed: false,
      // Shown while old payment links are still closing (pending) or a
      // payment needs a manual check (reconciliation required).
      blockedReason: `You cannot start a new membership application yet. Old payment links for this member are still being closed, or a payment needs a manual check. Refresh the page in a few minutes. If this message stays, email ${STAFF_SUPPORT_EMAIL}.`,
    };
  }

  if (hasUnsavedChanges) {
    return {
      allowed: false,
      blockedReason:
        "Select Save Changes or Reset for your changes first. Then select Submit New Company Membership Application.",
    };
  }

  if (!canStartNewApplication) {
    return {
      allowed: false,
      blockedReason:
        `This member cannot start a new membership application right now. If you think this is wrong, email ${STAFF_SUPPORT_EMAIL}.`,
    };
  }

  return { allowed: true };
};
